module.exports = __webpack_public_path__ + "img/question-diamond.0612ae28.svg";